import SysInfo from '../model/SysInfo';

class LoginStore{

  static async setSysInfo(){
    await SysInfo.setSysInfo();
    await SysInfo.setOrderFunction();
  }
}

export default LoginStore;
